import { type Fields, type FieldState } from '../../../types/Field';
import { type FieldName } from '../../../types/CardFieldName';

export const createFieldState = (mixin?: Partial<FieldState>): FieldState => ({
  value: '',
  isValid: false,
  isTouched: false,
  isEmpty: true,
  ...mixin,
});

export const createFieldsStates = (fieldNames: FieldName[]): Fields =>
  fieldNames.reduce<Fields>((accumulator: Fields, fieldName: string) => {
    accumulator[fieldName] = createFieldState();
    return accumulator;
  }, {});
